import { patch } from '@hummingbirdtechgroup/wings-request';

const patchFlightStatusCompleted = (apiUrl, flightId) => {
  return patch(apiUrl, `/v1/flights/${flightId}`, {
    upload_status: 'Completed',
  });
};

export default patchFlightStatusCompleted;
